module.exports = __webpack_public_path__ + "img/dier.cfcc0323.png";